import {
  Flex,
  VStack,
  Button,
  useDisclosure,
  Icon,
} from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useEditState from '../../../../../../common/src/hooks/useEditState';
import useFlowInputComponent from '../../../../hooks/useFlowsInputComponent';
import { FlowsQuestion } from '../../../../types/FlowsTypes';
import { CompanyLoan } from '../../../../types/CompanyScanTypes';
import CompanyLoanTable from './CompanyLoanTable';
import NewCompanyLoanModal from './NewCompanyLoanModal';

interface Props {
  question: FlowsQuestion;
}

const CompanyLoanInputComponent: React.FC<React.PropsWithChildren<Props>> = ({
  question,
}) => {
  const { t } = useTranslation();
  const { isOpen, onClose, onOpen } = useDisclosure();

  const { toBeEdited, setToBeEdited, editIndex, setEditIndex } =
    useEditState<CompanyLoan>();

  const {
    field: { value, onBlur },
    // error,
  } = useFlowInputComponent({ question, defaultValue: [] });

  const companyLoans = (value as CompanyLoan[] | undefined) || [];

  const addCompanyLoan = (companyLoan: CompanyLoan) => {
    onBlur({ name: question.id, value: [...companyLoans, companyLoan] });
  };

  const editCompanyLoan = (companyLoan: CompanyLoan, index: number) => {
    if (index > -1) {
      const newCompanyLoans = [...companyLoans];
      newCompanyLoans[index] = companyLoan;
      onBlur({ name: question.id, value: newCompanyLoans });
    }
  };

  const handleOnRemove = (index: number) => {
    onBlur({
      name: question.id,
      value: companyLoans.filter((_, _index) => _index !== index),
    });
  };

  const handleOnEdit = (companyLoan: CompanyLoan, index: number) => {
    setToBeEdited(companyLoan);
    setEditIndex(index);
    onOpen();
  };

  const handleOnClose = () => {
    setToBeEdited(undefined);
    setEditIndex(undefined);
    onClose();
  };

  return (
    <VStack spacing="4" align="stretch">
      {isOpen && (
        <NewCompanyLoanModal
          companyLoan={toBeEdited}
          isOpen={isOpen}
          onClose={handleOnClose}
          addCompanyLoan={addCompanyLoan}
          editCompanyLoan={(loan) => editCompanyLoan(loan, editIndex || 0)}
        />
      )}
      <CompanyLoanTable
        companyLoans={companyLoans}
        onEdit={handleOnEdit}
        onRemove={handleOnRemove}
      />
      <Flex justify="flex-end">
        <Button
          onClick={onOpen}
          leftIcon={<Icon name="GeneralActionsAdd" />}
          isDisabled={question.rules.is_disabled}
        >
          {t('FLOWS_COMPANY-SCAN_COMPANY-LOAN-INPUT_ADD-LOAN')}
        </Button>
      </Flex>
    </VStack>
  );
};

export default CompanyLoanInputComponent;
